export const FAQ = () => {
  const faqs = [
    {
      question: "Is this another self-help book?",
      answer: "No. Self-help books are written for people who want to feel better about staying the same. This is a discipline manual. It's written for people ready to kill their old self and build something dangerous."
    },
    {
      question: "Who is this for?",
      answer: "Men and women who are tired of their own excuses. People who've read every motivational book and still wake up weak. Entrepreneurs, athletes, and anyone who knows they're capable of more but keeps choosing comfort. If you're offended by brutal honesty, this isn't for you."
    },
    {
      question: "Why is it called 'contraband'?",
      answer: "Because it doesn't belong on public shelves. The methods inside are too raw, too aggressive, too effective. Monks don't publish their rituals. Convicts don't share their survival protocols. Millionaires don't expose their mental warfare tactics. Until now."
    },
    {
      question: "What makes this different from other discipline books?",
      answer: "Most books tell you what to do. This book makes you do it. It includes daily rituals, brutal accountability systems, and shame-based protocols that force execution. You don't read this book. You bleed through it."
    },
    {
      question: "Will this actually work for me?",
      answer: "Only if you're willing to be uncomfortable every single day. If you want easy, buy another book. If you want results that scar you permanently, start here."
    },
    {
      question: "How long does it take to see results?",
      answer: "Seven days. If you follow The Mirror Ritual and The Calendar Crucifixion for one week, you'll either quit or become unrecognizable. Most quit. Prove you won't."
    },
    {
      question: "Is there a money-back guarantee?",
      answer: "No. This isn't a product you test-drive. This is a commitment. Once you start, you either finish or admit you were never serious. No refunds. No hand-holding."
    },
    {
      question: "Can I buy this in stores?",
      answer: "No. Limited first edition. 500 copies. Pre-order only. Once they're gone, they're buried. No reprints. No public release."
    },
    {
      question: "What if I fail?",
      answer: "You probably will. Most people do. But at least you'll know exactly why,  and it won't be because the system failed. It'll be because you did."
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-secondary/20 to-void">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-5xl md:text-6xl font-black text-center mb-4 tracking-tight">
          <span className="text-blood-bright">Questions</span>
        </h2>
        <p className="text-center text-steel text-xl mb-16 italic">Raw Answers</p>
        
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="border border-smoke bg-card/10 backdrop-blur-sm p-6 transition-all hover:border-blood/50"
            >
              <h3 className="text-xl md:text-2xl font-bold text-blood-bright mb-3 uppercase tracking-wide">
                {faq.question}
              </h3>
              <p className="text-foreground text-base md:text-lg leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center border-t-2 border-blood pt-12">
          <p className="text-2xl md:text-3xl font-bold text-foreground mb-4">
            Still have questions?
          </p>
          <p className="text-lg text-steel">
            Good. That means you're thinking. But thinking won't change you. <span className="text-blood-bright font-semibold">Action will.</span>
          </p>
        </div>
      </div>
    </section>
  );
};
